import { ColorSchemesProps } from '../ChartOptions/Color/ColorScheme';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { checkMinRequiredCards } from '../ChartAxes/chartDataFunctions/checkMinRequiredCards';

const EmptyQuery = ({
  graphDimension,
  propKey,
  chartArea,
  graphTileSize,
  chartThemes,
  showEmptyQueryMessageWithSecurity,
}: {
  graphDimension: {
    width: string;
    height: string;
  };
  propKey: string;
  chartArea?: string;
  graphTileSize?: number;
  chartThemes?: ColorSchemesProps[];
  showEmptyQueryMessageWithSecurity?: boolean;
}) => {
  const { dashMode, chartControls, chartProperties, chartType } = useSelector(
    (state: RootState) => ({
      dashMode: state.tabTileProps.dashMode,
      chartControls: state.chartControls,
      chartProperties: state.chartProperties,
      chartType: state.chartProperties.properties[propKey].chartType,
    }),
  );
  const isEditMode = dashMode === 'Edit';

  return (
    <div
      style={{
        width: graphDimension.width,
        height: graphDimension.height,
        // display: isEditMode ? 'flex' : 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        border: chartArea ? 'none' : graphTileSize ? 'none' : '1px solid rgb(238,238,238)',
        backgroundColor: chartThemes?.[0]?.background,
        color: chartThemes?.[0]?.dark ? '#ffffff' : 'grey',
      }}
    >
      <div style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
        The visual is currently empty.
        <br />
        {!!chartControls.properties[propKey]?.chartErrorDetails
          ? ''
          : checkMinRequiredCards(chartProperties.properties[propKey], chartType)
            ? showEmptyQueryMessageWithSecurity
              ? 'No data matching the applied condition.'
              : 'No data matching the applied filter.'
            : 'Please add fields to populate the visual.'}
      </div>
    </div>
  );
};

export default EmptyQuery;
